import { Injectable, inject } from '@angular/core';

import { MarketGroupingConfig } from '@frontend/sports/common/client-config-data-access';
import { MediaQueryService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class SheetViewService {
    private mediaObserver = inject(MediaQueryService);
    private marketGroupingConfig = inject(MarketGroupingConfig);

    private readonly _isEnabled: boolean;

    constructor() {
        this._isEnabled = this.marketGroupingConfig.shouldShowSheetViewForAllMarkets && this.mediaObserver.isActive('xs');
    }

    get isEnabled(): boolean {
        return this._isEnabled;
    }
}
